import LocalizeInput from 'components/input/LocalizeInput';
import React, { useEffect } from 'react';
import { AdminVoucherCategoryDto, AdminVoucherCategoryRequestDto } from 'services/data-contracts';
import { InputField, useModelStateContext } from 'saladsoft-primitive';
import ModifyButtons from 'components/layouts/ModifyButtons';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import { toast } from 'react-toastify';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';

const VoucherCategoryEdit = ({
  voucherCategory,
}: {
  voucherCategory?: AdminVoucherCategoryDto;
}) => {
  const { uiStore } = useStoreWrapper();
  const { stateModel, setState, setMultipleState, serviceModel, unmountModel } =
    useModelStateContext<AdminVoucherCategoryRequestDto>();

  const handleUpdate = async () => {
    let result;
    if (voucherCategory?.id) {
      result = await ServiceHelper.adminVoucherService?.updateVoucherCategory(
        voucherCategory?.id,
        serviceModel.current as AdminVoucherCategoryRequestDto,
      );
    } else {
      result = await ServiceHelper.adminVoucherService?.createVoucherCategory(
        serviceModel.current as AdminVoucherCategoryRequestDto,
      );
    }
    if (result?.status === 200) {
      toast.success(`바우처 카테고리가 ${voucherCategory?.id ? '수정' : '추가'}되었습니다.`);
      uiStore?.modal.confirm();
    } else {
      const newResult = result as any;

      toast.error(newResult?.error?.data?.errorCode);
    }
  };

  const handleDelete = async () => {
    if (voucherCategory?.id) {
      const result = await ServiceHelper.adminVoucherService?.deleteVoucherCategory(
        voucherCategory?.id,
      );
      if (result?.status === 200) {
        toast.success('바우처 그룹이 삭제되었습니다.');
        uiStore?.modal.confirm();
      } else {
        const newResult = result as any;
        toast.error(newResult?.error?.data?.errorCode);
      }
    }
  };

  useEffect(() => {
    if (voucherCategory) {
      setMultipleState(voucherCategory);
    }
    return () => {
      unmountModel();
    };
  }, [voucherCategory]);

  return (
    <div style={{ paddingBottom: 40, padding: 20 }}>
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">바우처 그룹이름</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              바우처 그룹이름을 입력해주세요.
            </Text>
          </div>
          <div>
            <LocalizeInput
              value={stateModel?.localizedName}
              onChange={(value) => {
                setState('localizedName', value);
              }}
            />
          </div>
        </InnerGroup>
      </InnerSection>
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">바우처 그룹설명</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              바우처 그룹설명을 입력해주세요.
            </Text>
          </div>
          <div>
            <LocalizeInput
              value={stateModel?.localizedDesc}
              onChange={(value) => {
                setState('localizedDesc', value);
              }}
            />
          </div>
        </InnerGroup>
      </InnerSection>
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">비고</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              비고를 입력해주세요.
              <br />
              비고는 고객에게 표시되지 않습니다.
            </Text>
          </div>
          <InputField
            label="비고"
            value={stateModel?.remark}
            multiline
            rows={3}
            onChange={(value) => {
              setState('remark', value);
            }}
          />
        </InnerGroup>
      </InnerSection>

      <div>
        <ModifyButtons
          type={voucherCategory?.id ? 'update' : 'create'}
          showDelete={true}
          onCancel={() => {}}
          onSave={handleUpdate}
          onDelete={() => {
            handleDelete();
          }}
        />
      </div>
    </div>
  );
};

export default VoucherCategoryEdit;
